import React, { useState } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import useCustomer, { updateCustomerStatus } from "../../hooks/useCustomer";
import useApi from "../../hooks/useApi";

export default function CustomerList() {
  const [page, setPage] = useState(1);
  const perPage = 20;
  const { data, isLoading, isError, error } = useCustomer(page, perPage);
  const customers = data?.data || [];
  const meta = data?.meta || {};
  const totalPages = meta.last_page || 1;

  const [statusUpdating, setStatusUpdating] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("name");
  const [statusFilter, setStatusFilter] = useState("all");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [customerToDelete, setCustomerToDelete] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const { del } = useApi();
  const { mutate: deleteCustomer } = del("admin/customers");

  const paramobj = {
    toast: toast,
    setStatusUpdating: setStatusUpdating
  };
  const { updateStatus } = updateCustomerStatus(paramobj);

    const handleStatusChange = (customer, newStatus) => {
        setStatusUpdating(prev => ({ ...prev, [customer.customer_id]: true }));
        updateStatus({ id: customer.customer_id, payload: { status: newStatus } });
    };

  const handleDeleteClick = (customer) => {
    setCustomerToDelete(customer);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = () => {
    if (!customerToDelete) return;
    setDeleteLoading(true);
    setStatusUpdating((prev) => ({
      ...prev,
      [customerToDelete.customer_id]: true,
    }));
    deleteCustomer(customerToDelete.customer_id, {
      onSuccess: (result) => {
        if (result.success) {
          toast.success("Customer deleted!");
        } else {
          toast.error(result.message || "Failed to delete customer");
        }
      },
      onError: (error) => {
        toast.error(error?.message || "Failed to delete customer");
      },
      onSettled: () => {
        setStatusUpdating((prev) => ({
          ...prev,
          [customerToDelete.customer_id]: false,
        }));
        setDeleteLoading(false);
        setShowDeleteModal(false);
        setCustomerToDelete(null);
      },
    });
  };

  // Filter/search only on current page's data
  const filteredCustomers = customers.filter((customer) => {
    const matchesStatus =
      statusFilter === "all" || customer.status === statusFilter;
    const query = searchQuery.trim().toLowerCase();
    if (!query) return matchesStatus;

    let matches = false;
    if (filterType === "name") {
      matches = customer.name?.toLowerCase().includes(query);
    } else if (filterType === "id") {
      matches = String(customer.customer_id || customer.id) === query;
    } else if (filterType === "email") {
      matches = customer.email?.toLowerCase().includes(query);
    }
    return matchesStatus && matches;
  });

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  if (isLoading) {
    return (
      <div className="text-center py-4">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">Loading customers...</p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="alert alert-danger mt-4">{error}</div>
    );
  }

    return (
        <>
                            <div className="title-header option-title d-flex align-items-center justify-content-between">
                                <h2>All Customers</h2>
                                <div className="d-flex align-items-center">
                                    <select
                                        className="form-select form-select-sm w-auto me-2"
                                        value={filterType}
                                        onChange={e => setFilterType(e.target.value)}
                                    >
                                        <option value="name">Name</option>
                                        <option value="id">ID</option>
                                        <option value="email">Email</option>
                                    </select>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm me-2"
                                        style={{ width: 220 }}
                                        placeholder={`Search by ${filterType}...`}
                                        value={searchQuery}
                                        onChange={e => setSearchQuery(e.target.value)}
                                    />
                                    <select
                                        className="form-select form-select-sm w-auto"
                                        value={statusFilter}
                                        onChange={e => setStatusFilter(e.target.value)}
                                    >
                                        <option value="all">All Statuses</option>
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                </div>
                            </div>
                            {filteredCustomers.length === 0 ? (
                                <div className="text-center py-4">
                                    <p className="text-muted">No customers found</p>
                                </div>
                            ) : (
                  <>
                                <div className="table-responsive table-product">
                                    <table className="table all-package theme-table align-middle" id="table_id">
                                        <thead className="table-light">
                                            <tr>
                                                <th className="text-center">ID</th>
                                                <th className="text-start">Name</th>
                                                <th className="text-start">Email</th>
                                                <th className="text-start">Phone</th>
                                                <th className="text-center">Status</th>
                                                <th className="text-center">Option</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredCustomers.map((customer, idx) => (
                                                <tr key={idx}>
                                                    <td className="text-center">{customer.customer_id || customer.id}</td>
                                                    <td className="text-start">{customer.name}</td>
                                                    <td className="text-start">{customer.email}</td>
                                                    <td className="text-start">{customer.phone_no}</td>
                                                    <td className="text-center">
                                                        <div className="position-relative">
                                                            <select
                                                                className={`form-select form-select-sm w-auto ${customer.status === 'active' ? 'border-success' : 'border-danger'} ${statusUpdating[customer.customer_id] ? 'opacity-50' : ''}`}
                                                                value={customer.status}
                                                                onChange={e => handleStatusChange(customer, e.target.value)}
                                                                disabled={!!statusUpdating[customer.customer_id]}
                                                            >
                                                                <option value="active">Active</option>
                                                                <option value="inactive">Inactive</option>
                                                            </select>
                                                            {statusUpdating[customer.customer_id] && (
                                                                <>
                                                                    <div className="position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-75 rounded"></div>
                                                                    <div className="position-absolute top-50 start-50 translate-middle">
                                                                        <div className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <ul className="list-inline mb-0 d-flex align-items-center" style={{ gap: "4px" }}>
                                                            <li className="list-inline-item">
                                                                <Link to={`/customerdetails/${customer.customer_id}`} className="btn btn-sm btn-light p-1" style={{ lineHeight: 1, minWidth: 0 }}>
                                                                    <i className="ri-eye-line" style={{ cursor: 'pointer', fontSize: "16px" }}></i>
                                                                </Link>
                                                            </li>
                                                            <li className="list-inline-item">
                                                                <button
                                                                    onClick={() => handleDeleteClick(customer)}
                                                                    className="btn btn-sm btn-light p-1"
                                                                    style={{ border: "none", background: "none", padding: 0, lineHeight: 1, minWidth: 0 }}
                                                                    disabled={!!statusUpdating[customer.customer_id]}
                                                                >
                                                                    <i className="ri-delete-bin-line" style={{ cursor: 'pointer', fontSize: "16px", color: "#dc3545", verticalAlign: "middle" }}></i>
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                    {/* Pagination Controls */}
                    <nav className="d-flex justify-content-center mt-4">
                      <ul className="pagination">
                        <li className={`page-item${page === 1 ? ' disabled' : ''}`}>
                          <button className="page-link" onClick={() => handlePageChange(page - 1)} disabled={page === 1}>&laquo; Prev</button>
                        </li>
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((pg) => (
                          <li key={pg} className={`page-item${pg === page ? ' active' : ''}`}>
                            <button className="page-link" onClick={() => handlePageChange(pg)}>{pg}</button>
                          </li>
                        ))}
                        <li className={`page-item${page === totalPages ? ' disabled' : ''}`}>
                          <button className="page-link" onClick={() => handlePageChange(page + 1)} disabled={page === totalPages}>Next &raquo;</button>
                        </li>
                      </ul>
                    </nav>
                  </>
                            )}


      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowDeleteModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to delete customer "
                  {customerToDelete?.name}"? This action cannot be undone.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setShowDeleteModal(false)}
                  disabled={deleteLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleDeleteConfirm}
                  disabled={deleteLoading}
                >
                  {deleteLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Deleting...
                    </>
                  ) : (
                    "Delete"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
